const e = {
  name: "Store",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M4.2,0L1,12.9v1.6c0,2.1,1.2,4,3,4.9V38H0v2h40v-2h-4V19.4c1.8-0.9,3-2.8,3-4.9v-1.6L35.8,0H4.2z M34,38H6v-4
			h28V38z M6,32V20c0.2,0,0.3,0,0.5,0c1.9,0,3.5-0.9,4.5-2.3c1,1.4,2.6,2.3,4.5,2.3c1.9,0,3.5-0.9,4.5-2.3c1,1.4,2.6,2.3,4.5,2.3
			c1.9,0,3.5-0.9,4.5-2.3c1,1.4,2.6,2.3,4.5,2.3c0.2,0,0.3,0,0.5,0v12H6z M10,2v10H3.3L5.8,2H10z M3,14.5V14h7v0.5
			c0,1.9-1.6,3.5-3.5,3.5C4.6,18,3,16.4,3,14.5z M12,14.5V14h7v0.5c0,1.9-1.6,3.5-3.5,3.5S12,16.4,12,14.5z M21,14.5V14h7v0.5
			c0,1.9-1.6,3.5-3.5,3.5S21,16.4,21,14.5z M21,12V2h7v10H21z M30,14.5V14h7v0.5c0,1.9-1.6,3.5-3.5,3.5S30,16.4,30,14.5z M30,12V2
			h4.2l2.5,10H30z M12,12V2h7v10H12z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Store
};
